import React from "react";

function Banner() {
    return (
        <div className="Banner-section">

            <div className="container">

                {/* Content */}
                <div className="hero-content">

                    {/* Left Content */}
                    <div className="hero-left">

                        <h1>
                            Loyalty stamp passes for Apple Wallet and Google Wallet
                        </h1>

                        <p>
                            Build digital loyalty cards that keep customers coming back. Reward repeat visits, gain valuable customer insights, and send targeted updates and offers directly to your customer's mobile wallets. All without requiring them to download an app.
                        </p>

                        <div className="hero-btns">
                            <a href="/Pricing">Start your free 15-day trial</a>
                        </div>

                        <div className="hero-note">
                            <span className="check">
                                <svg width="17" height="17" fill="white" viewBox="0 0 640 640">
                                    <path d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z" />
                                </svg>
                            </span> No credit card needed to get started
                        </div>

                    </div>

                    {/* Right Image */}
                    <div className="hero-right">
                        <video autoPlay loop muted playsInline>
                            <source src="/banner-video.mp4" type="video/mp4" />
                        </video>
                    </div>

                </div>

            </div>

        </div>
    );
}

export default Banner;